import React, { useState } from 'react';
import { Printer, Package2, BarChart3, Clock, Zap, Shield, CheckCircle, ArrowRight, Phone, Mail, MapPin } from 'lucide-react';
import img1 from '../components/images/tto/53I.jpg'
import img2 from '../components/images/tto/107.jpg'
import img3 from '../components/images/tto/32TR.jpeg'
const SavemaTTODealer = () => {
  const [selectedSeries, setSelectedSeries] = useState('series-20');
  const [selectedModel, setSelectedModel] = useState('');

  const productSeries = {
    'series-20': {
      name: 'SAVEMA 20 Series',
      description: 'High-performance, cost-effective thermal transfer overprinters for industrial applications',
      models: [
        { id: '32i', image:img1, name: '32mm I (Intermittent)', width: '32mm', speed: 'Up to 300mm/s', features: ['Intermittent Operation', 'Form-Fill-Seal Integration', 'Compact Design'] },
        { id: '32c', image:img1, name: '32mm C (Continuous)', width: '32mm', speed: 'Up to 600mm/s', features: ['Continuous Operation', 'High Speed Production', 'Auto Bagger Compatible'] },
        { id: '53i', image:img1, name: '53mm I (Intermittent)', width: '53mm', speed: 'Up to 400mm/s', features: ['Wider Print Area', 'Logo & Graphics', 'Pharmaceutical Grade'] },
        { id: '107i', image:img2, name: '107mm I (Intermittent)', width: '107mm', speed: 'Up to 300mm/s', features: ['Large Format Printing', 'Complex Graphics', 'Multiple Data Fields'] }
      ]
    },
    'svm-series': {
      name: 'SAVEMA SVM Series',
      description: 'Advanced thermal transfer overprinters with superior performance and reliability',
      models: [
        { id: 'svm32', name: 'SVM32', width: '32mm', speed: 'Up to 100mm/s', features: ['Compact Design', 'High Resolution', 'Cost Effective'] },
        { id: 'svm53', name: 'SVM53', width: '53mm', speed: 'Up to 100mm/s', features: ['Medium Format', 'Graphics Capable', 'Versatile Applications'] },
        { id: 'svm107', name: 'SVM107', width: '107mm', speed: 'Up to 100mm/s', features: ['Large Format', 'High Resolution Graphics', 'Complex Data Printing'] },
        { id: 'svm128', name: 'SVM128', width: '128mm', speed: 'Up to 100mm/s', features: ['Wide Format', 'Maximum Print Area', 'Industrial Grade'] }
      ]
    },
    'tr-series': {
      name: 'SAVEMA TR Series',
      description: 'High-speed thermal transfer overprinters for large production runs',
      models: [
        { id: 'tr32', image:img3, name: 'TR32', width: '32mm', speed: 'Up to 600mm/s', features: ['Ultra High Speed', 'Variable Data', 'Production Line Ready'] },
        { id: 'tr53', image:img3, name: 'TR53', width: '53mm', speed: 'Up to 400mm/s', features: ['High Speed Graphics', 'Complex Data', 'Logo Capable'] },
        { id: 'tr107', image:img3, name: 'TR107', width: '107mm', speed: 'Up to 300mm/s', features: ['Large Format Speed', 'Serialized Data', 'Industrial Applications'] }
      ]
    }
  };

  const currentSeries = productSeries[selectedSeries];

  const applications = [
    { icon: Package2, title: 'Food & Beverage', description: 'Expiry dates, batch codes, nutritional info on flexible packaging' },
    { icon: Shield, title: 'Pharmaceutical', description: 'Serial numbers, manufacturing dates, regulatory compliance codes' },
    { icon: BarChart3, title: 'Automotive', description: 'Part numbers, traceability codes, quality control marks' },
    { icon: Clock, title: 'Cosmetics', description: 'Batch information, manufacturing dates, product codes' }
  ];

  const features = [
    'High-resolution printing up to 600dpi',
    'Variable data printing capabilities',
    '1D/2D barcode & DataMatrix support',
    'Sayasis Template Design Software',
    'Windows Driver Support',
    'USB connectivity for easy setup',
    'Robust mechanical design',
    'Low maintenance requirements'
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-stone-50 to-orange-50 font-poppins">
      {/* Header */}
      {/* <header className="relative overflow-hidden bg-gradient-to-r from-stone-800 to-amber-800 shadow-2xl">
        <div className="absolute inset-0 bg-gradient-to-r from-stone-900/20 to-amber-900/20"></div>
        <div className="relative max-w-7xl mx-auto px-6 py-12">
          <div className="text-center">
            <div className="flex items-center justify-center mb-6">
              <div className="flex items-center justify-center w-20 h-20 bg-gradient-to-br from-amber-400 to-orange-500 rounded-3xl shadow-2xl">
                <Printer className="w-10 h-10 text-white" />
              </div>
            </div>
            <h1 className="text-5xl lg:text-6xl font-bold text-white mb-4 tracking-tight">
              SAVEMA TTO Printers
            </h1>
            <p className="text-xl text-amber-100 mb-6 max-w-3xl mx-auto">
              Authorized dealer for high-performance thermal transfer overprinters - ideal for printing barcodes, expiry dates, batch codes and variable data on flexible packaging
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl px-4 py-2 text-amber-100">
                <span className="text-sm font-medium">Turkish Innovation</span>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl px-4 py-2 text-amber-100">
                <span className="text-sm font-medium">Industrial Grade</span>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl px-4 py-2 text-amber-100">
                <span className="text-sm font-medium">Cost Effective</span>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-amber-400 to-orange-500"></div>
      </header> */}

      {/* Product Series Selection */}
      
      <section className="py-16 bg-gradient-to-b from-stone-100 to-amber-100">
        {/* <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-amber-400 to-orange-500"></div> */}
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-stone-900 mb-4">Choose Your Series</h2>
            <p className="text-xl text-stone-600 max-w-3xl mx-auto">
              SAVEMA offers multiple series of TTO printers in 32mm, 53mm, 107mm, and 128mm widths for different industrial needs
            </p>
          </div>

          {/* Series Selection Tabs */}
          <div className="flex justify-center mb-12">
            <div className="bg-white/70 backdrop-blur-sm rounded-2xl p-2 shadow-xl border border-stone-200">
              {Object.entries(productSeries).map(([key, series]) => (
                <button
                  key={key}
                  onClick={() => setSelectedSeries(key)}
                  className={`px-8 py-4 rounded-xl font-semibold transition-all duration-300 ${
                    selectedSeries === key
                      ? 'bg-gradient-to-r from-amber-600 to-orange-600 text-white shadow-lg'
                      : 'text-stone-700 hover:bg-stone-100'
                  }`}
                >
                  {series.name}
                </button>
              ))}
            </div>
          </div>

          {/* Series Information */}
          <div className="bg-white/70 backdrop-blur-sm rounded-3xl shadow-xl border border-stone-200 p-8 mb-8">
            <div className="text-center mb-8">
              <h3 className="text-3xl font-bold text-stone-900 mb-4">{currentSeries.name}</h3>
              <p className="text-lg text-stone-600">{currentSeries.description}</p>
            </div>

            {/* Models Grid */}
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {currentSeries.models.map((model) => (
                <div
                  key={model.id}
                  className={`p-6 rounded-2xl border-2 cursor-pointer transition-all duration-300 ${
                    selectedModel === model.id
                      ? 'border-amber-500 bg-gradient-to-br from-amber-50 to-orange-50 shadow-xl'
                      : 'border-stone-200 hover:border-amber-300 bg-white/50 hover:shadow-lg'
                  }`}
                  onClick={() => setSelectedModel(model.id)}
                >
                  <div className="text-center mb-4">
                    <div className="w-20 h-20  rounded-2xl flex items-center justify-center mx-auto mb-3">
                      {/* <Printer className="w-8 h-8 text-white" /> */}
                        <img src={model.image}></img>
                    </div>
                    <h4 className="text-lg font-bold text-stone-900">{model.name}</h4>
                    <p className="text-sm text-stone-600">{model.width} Print Width</p>
                  </div>
                  
                  <div className="mb-4">
                    <div className="text-sm font-medium text-amber-700 mb-2">Speed: {model.speed}</div>
                  </div>

                  <div className="space-y-2">
                    {model.features.map((feature, index) => (
                      <div key={index} className="flex items-center text-sm text-stone-600">
                        <CheckCircle className="w-4 h-4 text-green-600 mr-2 flex-shrink-0" />
                        <span>{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Applications Section */}
      <section className="py-16 bg-gradient-to-br from-stone-50 to-amber-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-stone-900 mb-4">Industry Applications</h2>
            <p className="text-xl text-stone-600 max-w-3xl mx-auto">
              Suitable for all applications within food, pharmaceutical, cosmetics, and automobile spare parts industries
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {applications.map((app, index) => (
              <div key={index} className="bg-white/70 backdrop-blur-sm rounded-3xl p-8 shadow-xl border border-stone-200 hover:shadow-2xl transition-all duration-300">
                <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-amber-500 to-orange-600 rounded-2xl mb-6 mx-auto">
                  <app.icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-stone-900 mb-3 text-center">{app.title}</h3>
                <p className="text-stone-600 text-center">{app.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-gradient-to-r from-stone-100 to-amber-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-stone-900 mb-6">Why Choose SAVEMA TTO?</h2>
              <p className="text-lg text-stone-600 mb-8">
                SAVEMA TTO printers use advanced printing technology to produce high-quality, high-resolution codes, graphics, and text with durability and cost-effectiveness
              </p>
              
              <div className="grid gap-4">
                {features.map((feature, index) => (
                  <div key={index} className="flex items-center p-4 bg-white/70 backdrop-blur-sm rounded-xl shadow-sm border border-stone-200">
                    <CheckCircle className="w-6 h-6 text-green-600 mr-4 flex-shrink-0" />
                    <span className="text-stone-800 font-medium">{feature}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="relative">
              <div className="bg-white/70 backdrop-blur-sm rounded-3xl shadow-2xl border border-stone-200 p-8">
                <div className="bg-stone-900 rounded-2xl p-6 mb-6">
                  <div className="bg-white rounded-xl p-8 min-h-48 flex flex-col justify-center items-center">
                    <div className="text-center space-y-4">
                      <div className="text-stone-800 font-mono text-lg font-bold">SAVEMA TTO SAMPLE</div>
                      <div className="text-stone-600 font-mono text-sm">EXP: 15/12/2025</div>
                      <div className="text-stone-600 font-mono text-sm">BATCH: SVM2408251</div>
                      <div className="w-24 h-8 bg-stone-800 mx-auto rounded flex items-center justify-center">
                        <BarChart3 className="w-6 h-6 text-white" />
                      </div>
                      <div className="text-xs text-stone-500">Sample print output</div>
                    </div>
                  </div>
                  <p className="text-stone-400 text-sm text-center">High-resolution variable data printing</p>
                </div>

                <div className="text-center">
                  <button className="bg-gradient-to-r from-amber-600 to-orange-600 hover:from-amber-700 hover:to-orange-700 text-white font-semibold py-4 px-8 rounded-2xl transition-all duration-300 transform hover:scale-105 hover:shadow-xl">
                    <Zap className="w-5 h-5 inline mr-2" />
                    Request Demo
                  </button>
                </div>
              </div>

              {/* Decorative Elements */}
              <div className="absolute -top-6 -right-6 w-32 h-32 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full opacity-20 blur-2xl"></div>
              <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-gradient-to-br from-stone-400 to-amber-400 rounded-full opacity-20 blur-2xl"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 bg-gradient-to-br from-stone-800 to-amber-800">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-white mb-4">Get In Touch</h2>
            <p className="text-xl text-amber-100 max-w-3xl mx-auto">
              Ready to enhance your packaging line with SAVEMA TTO printers? Contact our experts for consultation and pricing.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              { icon: Phone, title: 'Call Us', info: '+555 3500531', action: 'Call Now' },
              { icon: Mail, title: 'Email Us', info: 'www.tsgce-sa.com', action: 'Send Email' },
              { icon: MapPin, title: 'Visit Us', info: 'Al-khobar, Saudi Arabia', action: 'Get Directions' }
            ].map((contact, index) => (
              <div key={index} className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 text-center hover:bg-white/20 transition-all duration-300">
                <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-amber-400 to-orange-500 rounded-2xl mb-6 mx-auto">
                  <contact.icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3">{contact.title}</h3>
                <p className="text-amber-100 mb-4">{contact.info}</p>
                <button className="text-amber-300 hover:text-white font-medium flex items-center justify-center mx-auto transition-colors duration-200">
                  {contact.action} <ArrowRight className="w-4 h-4 ml-2" />
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-stone-900 text-stone-300 py-12">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <div className="flex items-center justify-center mb-6">
            <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-br from-amber-600 to-orange-600 rounded-xl mr-4">
              <Printer className="w-6 h-6 text-white" />
            </div>
            <span className="text-2xl font-bold text-white">SAVEMA TTO Dealer</span>
          </div>
          <p className="text-stone-400 mb-4">Authorized dealer for SAVEMA Thermal Transfer Overprinters</p>
          <p className="text-sm text-stone-500">All rights reserved. SAVEMA is a trademark of SAVEMA Ltd.</p>
        </div>
      </footer>
    </div>
  );
};

export default SavemaTTODealer;